import axios from "axios";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class TourPackageService {

  static gettravelPackageList(item) {
    // Initialize the base API URL
    let api = `${API_BASE_URL}${API_PATHS.gettravelPackage}`;
    
    // Start building query parameters
    const params = new URLSearchParams();
  
    if (item?.id) {
      params.append("id", item.id);
    } else if (item?.packageSlug) {
      params.append("packageSlug", item.packageSlug);
    } else if (item?.categorySlug) {
      params.append("categorySlug", item.categorySlug);
    }

    if (item?.limit) {
      params.append("limit", item.limit);
    }
    if (item?.page) {
      params.append("page", item.page);
    }

    if (item?.duration) {
      params.append("duration", item.duration);
    }
    if (item?.priceRange) {
      params.append("minPrice", item.priceRange[0]);
      params.append("maxPrice", item.priceRange[1]);
    }

    api = `${api}?${params.toString()}`;
    
    // Make the API request
    return axios
      .get(api)
      .then((response) => {
        if (response.data) {
          // Process response data if needed
        }

        return response.data;
      })
      .catch((error) => {
        console.error("Error:", error);
        throw error;
      });
  }
  

    static gettravelCategoryList(item) {
  
      let api = '';
      
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.gettravelCategory}?id=${item?.id}`
      } else{
      api = `${API_BASE_URL}${API_PATHS.gettravelCategory}?limit=${item?.limit}`;
      }
       return axios
        .get(api)
        .then((response) => {
          if (response.data) {
          }
          return response.data;
        })
        .catch((error) => {
          console.error("Error:", error);
          throw error;
        });
    }

    static getsimilarPackage(item) {
  
      let api = '';
      
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.getsimilarpackage}?id=${item?.id}`
      } 
       return axios
        .get(api)
        .then((response) => {
          if (response.data) {
          }
          return response.data;
        })
        .catch((error) => {
          console.error("Error:", error);
          throw error;
        });
    }
    static getspecialPackage(item) {
  
      let api = '';
      
      if(item?.id){
        api= `${API_BASE_URL}${API_PATHS.getspecialpackage}?id=${item?.id}`
     } else{
     api = `${API_BASE_URL}${API_PATHS.getspecialpackage}`;
     } 
       return axios
        .get(api)
        .then((response) => {
          if (response.data) {
          }
          return response.data;
        })
        .catch((error) => {
          console.error("Error:", error);
          throw error;
        });
    }
    static postenquiry(item) {
  
      let api = '';
      
      
     api = `${API_BASE_URL}${API_PATHS.postenquiry}`;
     
       return axios
        .post(api,item)
        .then((response) => {
          if (response.data) {
          }
          return response.data;
        })
        .catch((error) => {
          console.error("Error:", error);
          throw error;
        });
    }
    static travelpackageprice(item) {
  
      let api = '';
      
      
     api = `${API_BASE_URL}${API_PATHS.travelpackageprice}`;
     
       return axios
        .post(api,item)
        .then((response) => {
          if (response.data) {
          }
          return response.data;
        })
        .catch((error) => {
          console.error("Error:", error);
          throw error;
        });
    }

  

  
}

export default TourPackageService;